export default {
  ooredooPath: "imadrassa.com",
  waitingTime: 5000, // 5s temps d'attente avant la redirection
  waitingTimeTest: 30000, // 5s temps d'attente avant la redirection
  paiementUrl: "https://ooredoo.imadrassa.com",
  notifApi: "http://redirection.ooredoo.imadrassa.com/test",
};
